import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";

import InProgressTableDoctors from "../components/InProgressTableDoctors";
import InProgressSearchDoctors from "../components/InProgressSearchDoctors";
import Grid from "@mui/material/Unstable_Grid2";

const OrdersInProgressDoctors = (props) => {
  const [inProgress, setInProgress] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [labNames, setlabNames] = useState([]);

  //getting the data from search component
  const getOrderData = (data, count, labNames) => {
    setInProgress(data);
    setPageCount(count);
    setlabNames(labNames);
  };

  //getting the data from the pagination
  const getPage = (data) => {
    setPage(data);
  };

  //test
  // useEffect(() => {
  //   console.log(inProgress);
  // }, [inProgress]);

  return (
    <React.Fragment>
      <Grid container justifyContent={"center"}>
        <Grid md={12}>
          <InProgressSearchDoctors
            getOrderData={getOrderData}
            page={page}
            rowCount={15}
          />
        </Grid>
        <Grid md={12}>
          <InProgressTableDoctors
            data={inProgress}
            getPage={getPage}
            pageCount={pageCount}
            labNames={labNames}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default OrdersInProgressDoctors;
